module.exports = __webpack_public_path__ + "static/media/thank-you-notes-v2.76bc2711.svg";